/**
 * Opus is laid from four pieces built on a module L (the smallest square):
 * 2L×2L, 3L×2L, 2L×L and L×L, one image each, in that order. A variant stores
 * them as one plank list in that order; the seamless worker takes the first
 * four and repeats the list when it is shorter. One image serves all four
 * pieces; two or three leave pieces guessed; past four, the rest is ignored.
 * The variant's size is the smallest square.
 */

export const OPUS_PIECES = ['LARGE_SQUARE', 'LARGE_RECTANGLE', 'SMALL_RECTANGLE', 'SMALL_SQUARE'] as const;

/** Each piece's size in modules (width × height), in the order the worker lays them. */
export const OPUS_PIECE_MODULES: ReadonlyArray<[number, number]> = [[2, 2], [3, 2], [2, 1], [1, 1]];

export const isOpusPattern = (pattern: unknown): boolean =>
  typeof pattern === 'string' && pattern.toLowerCase().replace(/[\s_-]+/g, '') === 'opus';

/** One image for every piece, or one image per piece (older products may carry more). */
export const isOpusImageCountValid = (count: number): boolean => count === 1 || count >= OPUS_PIECES.length;
